import Vue from 'vue'
import App from './App.vue'
//import './modules/registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './modules/vuetify'
import JsonViewer from 'vue-json-viewer'
import './style/index.scss'
import './helper';
import './modules/axios.middleware';


Vue.use(JsonViewer)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
